import React, { useContext, createContext, useEffect, useState } from 'react';
import moment from 'moment';

export function ProvideFilterContext({ children }) {
  const auth = useProvideFilterContext();
  return (
    <SharedFilterContext.Provider value={auth}>
      {children}
    </SharedFilterContext.Provider>
  );
}

export function useFilterContext() {
  return useContext(SharedFilterContext);
}


export function useProvideFilterContext() {
  const params = new URLSearchParams(window.location.search);
  const defaultStartDate = moment().subtract(1, 'month').endOf("day").format("YYYY-MM-DD");
  const defaultEndDate = moment().endOf("day").format("YYYY-MM-DD");

  const isValidDate = (str) => str && moment(str, 'YYYY-MM-DD', true).isValid();
  const urlStartDate = params.get('startDate');
  const urlEndDate = params.get('endDate');

  const [startDate, setStartDate] = useState(
    isValidDate(urlStartDate) ? urlStartDate : defaultStartDate
  );
  const [endDate, setEndDate] = useState(
    isValidDate(urlEndDate) ? urlEndDate : defaultEndDate
  );
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedRoutine, setSelectedRoutine] = useState(null);
  const [selectedEquipmentList, setSelectedEquipmentList] = useState([]);
  const [propertyEquipmentList, setPropertyEquipmentList] = useState([]);
  
  // New state for inspection view persistence
  const [inspectionViewMode, setInspectionViewMode] = useState('inspection');
  const [selectedPropertyList, setSelectedPropertyList] = useState(null);

  // Cache for favorited and property list IDs for filtering
  const [favoritedPropertyIds, setFavoritedPropertyIds] = useState([]);
  const [propertyListIds, setPropertyListIds] = useState([]);
  const [availablePropertyLists, setAvailablePropertyLists] = useState([]);
  const [hasFavorites, setHasFavorites] = useState(false);
  const [hasPropertyLists, setHasPropertyLists] = useState(false);

  // const lastSelectedEquipment = React.useMemo(
  //   () => _.last(selectedEquipmentList]
  // ), [selectedEquipmentList]);

  const setSelectedRootEquipment = (equipment) => {
    setSelectedEquipmentList([equipment]);
  }

  const updateEquipmentFromProperty = (updatedEquipment) => {
    const otherEquipment = propertyEquipmentList.filter(x => x.id !== updatedEquipment.id);
    setPropertyEquipmentList([...otherEquipment, updatedEquipment]);
  }


  useEffect(() => {
    () => {
      console.log("sharedFilterChanged: ", {startDate, endDate, selectedProperty, selectedRoutine, selectedEquipmentList});
    }
  }, [startDate, endDate, selectedProperty, selectedRoutine, selectedEquipmentList]);

  return {
    startDate,
    endDate,
    selectedProperty,
    selectedRoutine,
    setSelectedProperty: (property) => {
      console.log("SET A PROPERTY INTO SHARED FILTER CONTEXT")
      setSelectedProperty(property);
    },
    setSelectedRoutine,
    defaultStartDate,
    defaultEndDate,
    setStartDate,
    setEndDate,
    selectedEquipmentList,
    setSelectedEquipmentList,
    setSelectedRootEquipment,
    propertyEquipmentList,
    setPropertyEquipmentList,
    updateEquipmentFromProperty,
    // New inspection view persistence
    inspectionViewMode,
    setInspectionViewMode,
    selectedPropertyList,
    setSelectedPropertyList,
    // Cache for filtering
    favoritedPropertyIds,
    setFavoritedPropertyIds,
    propertyListIds,
    setPropertyListIds,
    availablePropertyLists,
    setAvailablePropertyLists,
    hasFavorites,
    setHasFavorites,
    hasPropertyLists,
    setHasPropertyLists
  };
}

const SharedFilterContext = createContext({});
export default SharedFilterContext;
